"use client";
import { useAnalytics } from '@/hooks/useAnalytics';
import { FloatingSearchAnalytics} from '@/lib/analyticsName';

interface ShowFloatingSearchProps {
  searchRefData?: React.RefObject<HTMLDivElement | null>;
  topPosition?: string;
}

const FloatingSearch = ({ 
  searchRefData, 
  topPosition, 
}: ShowFloatingSearchProps) => {
  const { trackButtonClick } = useAnalytics();

  const handleFloatingClick = () => {
    // Track floating search click
    trackButtonClick(FloatingSearchAnalytics.Desktop, FloatingSearchAnalytics.Category, {
      button_type: FloatingSearchAnalytics.Desktop,
      button_text: FloatingSearchAnalytics.Text,
    });

    searchRefData?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  return (
    <div
      style={{ top: topPosition }}
      className="fixed left-1/2 -translate-x-1/2 z-40 w-[95%] sm:w-[418px] mx-auto bg-white rounded-full shadow-[0_0_15px_rgba(0,0,0,0.15)] border border-[#F4F4F4] p-1 cursor-pointer"
      onClick={handleFloatingClick}
    >
      <div className="flex items-center justify-between bg-[#F4F4F4] rounded-[57px] px-4 py-1 gap-3 w-full">
        <span className="text-[16px] sm:text-[18px] font-medium text-black/50 select-none">
          Search
        </span>
        <svg
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="9" cy="9" r="7" stroke="#F05A24" strokeWidth="2" />
          <path
            d="M15 15L19 19"
            stroke="#F05A24"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default FloatingSearch;